import Typography from '@mui/material/Typography'
import Card from '@mui/material/Card'
import DownloadIcon from '@mui/icons-material/Download'
import { Button } from '@mui/material'

import axios, { pluckData } from 'src/utilities/http-client'
import { useAppDispatch } from 'src/store/hooks'
import { downloadFile } from 'src/v3/utilities/filesystem'
import { errorMessageChanged } from '../../admin.slice'

let exportAllUsers = () =>
  axios.get<unknown>('/api/v2/admin/users/export').then(pluckData)

export default () => {
  let dispatch = useAppDispatch()

  return (
    <Card sx={{ p: 2 }}>
      <Typography
        variant="h6"
        sx={{ fontFamily: 'revert', textAlign: 'center' }}
      >
        All Users
      </Typography>
      <div className="mt-2 flex justify-center">
        <Button
          variant="outlined"
          startIcon={<DownloadIcon />}
          onClick={() =>
            exportAllUsers()
              .then((response: any) => downloadFile(response, 'all_users.csv'))
              .catch((err) =>
                dispatch(
                  errorMessageChanged(
                    `CSV Export Failed: ${err.response?.data || err}`,
                  ),
                ),
              )
          }
        >
          Download CSV
        </Button>
      </div>
    </Card>
  )
}
